var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_626_19929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1502 7.14L9.44023 8.95L6.19023 4.97L1.49023 8.95V13.46H16.1302V10.75V8.95L12.1502 7.14Z",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7202 4.43001C13.4216 4.43001 13.9902 3.86142 13.9902 3.16001C13.9902 2.45861 13.4216 1.89001 12.7202 1.89001C12.0188 1.89001 11.4502 2.45861 11.4502 3.16001C11.4502 3.86142 12.0188 4.43001 12.7202 4.43001Z",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.62 15H0V0H17.62V15ZM0.9 14.1H16.71V0.9H0.9V14.1Z",
    fill: "#444444"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_626_19929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.62,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImage);
export default __webpack_public_path__ + "static/media/icon_image.5ba5177df57ba2f9778ba3b608c29489.svg";
export { ForwardRef as ReactComponent };